import "../css/ReserveBlock.css";
import ButtonYellow from './ButtonYellow';
import { getBikes } from '../getBikes'
import { useEffect, useState } from 'react';

const ReserveBlock = ({information, showForm, setShowForm, text, lang}) => {
   
    const [showLoader, setShowLoader] = useState(false)
    const today = new Date().toISOString().split("T")[0];
    const [bikes, setBikes] = useState([]);
    useEffect(() => {
        getBikes().then(setBikes)
    }, [])

    const submitForm = () => {
        setShowLoader(true)
        fetch("https://script.google.com/macros/s/AKfycby1JCPyvXAYvAW_tQVpiik4ppYZZJreuN4jKggWVvWYUYRArzBYonjjRDYOnPeT9_gK/exec", {
            method: "POST",
            body: JSON.stringify({
                city: document.querySelector('[data-id="location"] > select').value,
                height: document.querySelector('[data-id="height"] > input').value,
                model: bikes.find(el => el._id === document.querySelector('[data-id="model"] > select').value).name,
                weight: document.querySelector('[data-id="weight"] > input').value,
                date: document.querySelector('[data-id="date"] > input').value,
                level: document.querySelector('[data-id="level"] > select').value,
                phone: document.querySelector('[data-id="phone"] > input').value,
                email: document.querySelector('[data-id="email"] > input').value,
                guide: document.querySelector('[data-id="guide"] > input').checked,
                delivery: document.querySelector('[data-id="delivery"] > input').checked,
            })
            })
            .then(res => res.text())
            .then(data => {
                console.log(data)
                if (data === "success"){
                    setShowForm(true)
                }
                else{
                    alert('Fill all fields please')
                }
                setShowLoader(false)
            });
    }
    return (
        <div id="reserve_block" className="reserve_block">
            <div className={showForm ? "reserve_success_form" : "reserve_success_form hidden"}>
                <div>
                    <div>{text['send']?.[lang]}</div>
                    <div>{text['reach']?.[lang]}</div>
                    <div>{text['thanks']?.[lang]}</div>
                </div>
                <span onClick={() => setShowForm(false)}>x</span>
            </div>
            <div className={showLoader ? "spinner": "spinner.hidden"} role="status">
            </div>
            <h3>{text["title_3"]?.[lang]}</h3>
            <h6>{text["subtitle_3"]?.[lang]}</h6>
            <div className="reserve_form">
                <div>
                    <label data-id="location">
                        <div>{text["choose_location"]?.[lang]}</div>
                        <select>
                            <option value="borjomi">{text["borjomi"]?.[lang]}</option>
                            <option value="bakuriani">{text["bakuriani"]?.[lang]}</option>
                            <option value="tbilisi">{text["tbilisi"]?.[lang]}</option>
                            <option value="batumi">{text["batumi"]?.[lang]}</option>
                            <option value="kutaisi">{text["kutaisi"]?.[lang]}</option>
                            <option value="mtskheta">{text["mtskheta"]?.[lang]}</option>
                            <option value="gudauri">{text["gudauri"]?.[lang]}</option>
                            <option value="kazbegi">{text["kazbegi"]?.[lang]}</option>
                            <option value="signagi">{text["signagi"]?.[lang]}</option>
                            <option value="telavi">{text["telavi"]?.[lang]}</option>
                            <option value="zugdidi">{text["zugdidi"]?.[lang]}</option>
                            <option value="mestia">{text["mestia"]?.[lang]}</option>
                            <option value="kobuleti">{text["kobuleti"]?.[lang]}</option>
                            <option value="gonio">{text["gonio"]?.[lang]}</option>
                            <option value="tskaltubo">{text["tskaltubo"]?.[lang]}</option>
                        </select>
                    </label>
                    <label data-id="model">
                        <div>{text["select_bike_model"]?.[lang]}</div>
                        <select id="bike_model">
                            {bikes.map(bike => (<option key={bike._id} value={bike._id}>{bike.name}</option>))}
                        </select>
                    </label>
                    <label data-id="height">
                        <div>{text["your_height"]?.[lang]}</div>
                        <input id="height" type='number' placeholder='0'/>
                    </label>
                    <label data-id="weight">
                        <div>{text["your_weight"]?.[lang]}</div>
                        <input type='number' placeholder='0' />
                    </label>
                    <label data-id="date">
                        <div>{text["rental_date"]?.[lang]}</div>
                        <input type='date' defaultValue={today} />
                    </label>
                    
                    
                    <label data-id="level">
                        <div>{text["experience_level"]?.[lang]}</div>
                        <select>
                            <option value="starter">{text["starter"]?.[lang]}</option>
                            <option value="medium">{text["medium"]?.[lang]}</option>
                            <option value="professional">{text["professional"]?.[lang]}</option>
                        </select>
                    </label>

                    <label data-id="phone">
                        <div>{text["your_phone"]?.[lang]}</div>
                        <input type='phone' placeholder='+995 XXX XXX XXX' />
                    </label>
                    <label data-id="email">
                        <div>{text["your_email"]?.[lang]}</div>
                        <input type='email' placeholder='your_email@gmail.com'/>
                    </label>

                </div>
                <label data-id="guide"><input type="checkbox" /><div>{text["need_a_personal_guide"]?.[lang]}</div></label>
                <label data-id="delivery"><input type="checkbox" /><div>{text["hotel_delivery"]?.[lang]}</div></label>
                <ButtonYellow text={text["book_now"]?.[lang]} onclick={() => {submitForm()}} disabled={showLoader}/>
                <span>
                    <span>
                        {text['or']?.[lang]}
                    </span>
                </span>
                <a href={`https://wa.me/${information["whatsapp_number"]}`} target="_blank" rel="noopener noreferrer" >
                    <div className="button_transparent" onClick={() => {}}>{text['call_whatsapp']?.[lang]}</div>
                </a>
                <a target="_blank" rel="noreferrer" href={`https://t.me/${information["telegram_username"]}`}>
                    <div className="button_transparent" onClick={() => {}}>{text['call_telegram']?.[lang]}</div>
                </a>
                <a target="_blank" rel="noreferrer" href={`tel:${information["call_number"]}`}>
                    <div className="button_transparent" onClick={() => {}}>{`${text['call']?.[lang]} ${information["call_number"]}`}</div>
                </a>
            </div>
        </div>
    )
}

export default ReserveBlock;